import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "text"
};
export default {
  __name: 'Generating',
  props: {
    message: {
      type: String,
      default: '任务正在执行'
    }
  },
  setup(__props) {
    // eslint-disable-next-line

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createStaticVNode("<div class=\"wave\" data-v-7523b75b><div class=\"bar\" data-v-7523b75b></div><div class=\"bar\" data-v-7523b75b></div><div class=\"bar\" data-v-7523b75b></div><div class=\"bar\" data-v-7523b75b></div><div class=\"bar\" data-v-7523b75b></div><div class=\"bar\" data-v-7523b75b></div><div class=\"bar\" data-v-7523b75b></div><div class=\"bar\" data-v-7523b75b></div><div class=\"bar\" data-v-7523b75b></div><div class=\"bar\" data-v-7523b75b></div></div>", 1)), _createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString(__props.message), 1)])])]);
    };
  }
};